import { Component, inject } from '@angular/core'
import { AddRecordContentComponent } from '@app/feature/add-record/add-record-content.component'
import { ManageFieldsComponent } from '@app/feature/manage-fields/manage-fields.component'
import { PinDraftRecord } from '@app/feature/pin-panel/pin-record.service'
import { ModalFlowManagerService } from '@components-library/tb-modal-manager/modal-flow-manager.service'
import { ModalManagerService } from '@components-library/tb-modal-manager/modal-manager.service'
import { TbMoreMenuComponent } from '@components-library/tb-more-menu/tb-more-menu.component'
import { isNonNull } from '@core/global-util'
import { Schema } from '@core/models'
import { SchemaFacadeService } from '@core/services/store-facade'
import { filter, Observable } from 'rxjs'
import { take } from 'rxjs/operators'
import { TbMenuListItemComponent } from '@components-library/tb-menu-list-item/tb-menu-list-item.component'
import { TbMenuListComponent } from '@components-library/tb-menu-list/tb-menu-list.component'
import { TbButtonComponent } from '@components-library/tb-button/tb-button.component'

import { AsyncPipe } from '@angular/common'
import { TranslocoModule } from '@jsverse/transloco'
import { ModalLayoutComponent } from '@components-library/tb-modal-manager/modal-layout/modal-layout.component'

@Component({
    selector: 'app-header-name',
    templateUrl: './header-name.component.html',
    imports: [
        TranslocoModule,
        TbButtonComponent,
        TbMenuListComponent,
        TbMenuListItemComponent,
        AsyncPipe,
        TbMoreMenuComponent,
        ModalLayoutComponent,
    ],
})
export class HeaderNameComponent {
    private readonly schemaFacadeService = inject(SchemaFacadeService)
    private readonly modalFlowManagerService = inject(ModalFlowManagerService)

    readonly selectedSchema$: Observable<Schema> =
        this.schemaFacadeService.selectSelectedTableSchema$.pipe(filter(isNonNull))

    newRecord() {
        this.modalFlowManagerService
            .openDialog<AddRecordContentComponent, PinDraftRecord | null>({
                component: AddRecordContentComponent,
            })
            .pipe(take(1))
    }

    manageFields(modalManager: ModalManagerService) {
        modalManager.openDialog({ component: ManageFieldsComponent })
    }
}
